/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { Input, InputNumber, Select, Form, Button, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import CustomModal from '../../components/modal/Modal';
import DokanSettingsFieldLabel from '../../components/text/DokanSettingsFieldLabel';

const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function WithdrawCreate({
    handleClose,
    visible,
    showAlert,
    responseMessage,
    onFinish,
    tiny_loader,
    form,
    checkAmount,
    handleChangeInput,
    withdrawRequest,
    withdrawBalance,
    amtvalidationText,
}) {
    return (
        <>
            <CustomModal title="" onClose={handleClose} show={visible}>
                {showAlert && (
                    <div className="withdraw-alert-error">{responseMessage?.message}</div>
                )}
                <Form onFinish={onFinish} form={form}>
                    <Spin indicator={antIcon} spinning={tiny_loader}>
                        <div className="flex flex-col">
                            <div>
                                <DokanSettingsFieldLabel>Withdraw Amount</DokanSettingsFieldLabel>
                                <Form.Item
                                    name="amount"
                                    rules={[
                                        { required: checkAmount, message: `${amtvalidationText}` },
                                    ]}
                                >
                                    <Input
                                        style={{ width: '100%' }}
                                        value={withdrawRequest.amount}
                                        onChange={(e) =>
                                            handleChangeInput(e.target.value, 'amount')
                                        }
                                        placeholder="Enter Withdraw Amount"
                                    />
                                    <span className="font-normal text-tertiary">
                                        (Mininum amount ${withdrawBalance.withdraw_limit})
                                    </span>
                                </Form.Item>
                            </div>
                            <div>
                                <DokanSettingsFieldLabel>Payment Method</DokanSettingsFieldLabel>
                                <Form.Item
                                    name="method"
                                    rules={[{ required: true, message: 'Select withdraw option' }]}
                                >
                                    <Select
                                        size="large"
                                        style={{ width: '100%' }}
                                        value={withdrawRequest.method}
                                        onChange={(val) => handleChangeInput(val, 'method')}
                                        placeholder="Select a Payment Method"
                                    >
                                        <Option value="paypal">PayPal</Option>
                                        <Option value="bank">Bank</Option>
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                        <div className="flex justify-end items-center space-x-5">
                            <div>
                                <Form.Item>
                                    <button
                                        type="button"
                                        className="py-2 px-4 rounded-md border border-indigo-400 font-semibold"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item>
                                    <button
                                        type="submit"
                                        className="py-2 px-4 bg-green-500 border border-green-400 text-white font-semibold rounded-md"
                                    >
                                        Submit Request
                                    </button>
                                </Form.Item>
                            </div>
                        </div>
                    </Spin>
                </Form>
            </CustomModal>
        </>
    );
}

export default WithdrawCreate;
